<div class="modal-header">
  <h4 class="modal-title sign-bold">
    {{ "Sign.Title" | translate }}
  </h4>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  ></button>
</div>
<div class="modal-body">
  <p>
    {{ "Sign.Body" | translate }}
  </p>
  <label for="name" class="sign-bold pb-1">
    {{ "Sign.Label" | translate }}</label
  >
  <div>
    <input
      id="name"
      type="text"
      [formControl]="name"
      placeholder="Ex: John Doe"
    />
  </div>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-link text-decoration-none"
    (click)="activeModal.close()"
  >
    {{ "Sign.Cancel" | translate }}
  </button>
  <button class="btn btn-dark" (click)="submit()" [disabled]="!name.value">
    {{ "Sign.Submit" | translate }}
  </button>
</div>
